import { Flex, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { MONTH_ABBREVIATION } from 'utils';

type Dates = {
    id: number;
    start: Date;
    end: Date;
    price: number;
};

type PeriodTileProps = {
  dates: Dates[];
  onClick: (id: number) => void;
};

const PeriodTile = ({ dates, onClick }: PeriodTileProps) => {
    const [id, setId] = useState<number>(3);

  return (
    <Flex>
        {dates.map((date, index) => 
        <Flex cursor='pointer' key={index} justifyContent='space-between' marginRight={5} onClick={() => { setId(date.id); onClick(date.id); }}>
            <Flex flexDirection='column' align='center'width={250} backgroundColor={id === date.id ? '#3498FE' : '#F9F9F9'} padding={5} borderRadius='20px'>
                <Flex align='center'>
                    <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color={id === date.id ? 'white' : '#000000'}>
                        {`${date.start.getDate()} ${MONTH_ABBREVIATION[date.start.getMonth()]} -`}{'  '}
                    </Text>
                    <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color={id === date.id ? 'white' : '#000000'}>
                        {`${date.end.getDate()} ${MONTH_ABBREVIATION[date.end.getMonth()]}`}
                    </Text>
                </Flex>
                <Text align='center' fontFamily='Montserrat' fontSize='16px' fontWeight={700} color={id === date.id ? 'white' : '#000000'}>
                    {date.price}
                </Text>
            </Flex>
        </Flex>
        )}
        </Flex>
  );
};

export { PeriodTile };
